import { Components, createTheme, Theme } from "@mui/material/styles";

const baseTheme = createTheme();

const MuiSelect: Components<Theme>["MuiSelect"] = {
  styleOverrides: {
    root: {
      backgroundColor: "#fcf8f4",
      "&.Mui-disabled": {
        backgroundColor: baseTheme.palette.action.disabledBackground,
        borderColor: baseTheme.palette.action.disabled,
        cursor: "default",
      },
    },
  },
};

export default MuiSelect;
